import * as amplitude from "@amplitude/analytics-browser";
import { isRedoEmailAddress } from "@redotech/account-common/redo-domains";
import { useHandler } from "@redotech/react-util/hook";
import { UserContext } from "@redotech/redo-merchant-app-common/user";
import { useContext } from "react";
import { PlatformEvents } from "../../platform-events";

/** Where a switch between the experiences was made. */
export type ReturnsExperienceSwitchSource =
  | "invite_modal"
  | "classic_tables"
  | "home_header";

/** How the opt-in modal was closed without opting in. */
export type ReturnsExperienceModalDismissal = "not_now" | "closed";

type ReturnsExperienceEvent = (typeof PlatformEvents)[
  | "RETURN_DETAILS_EXPERIENCE_SWITCHED"
  | "RETURNS_EXPERIENCE_INVITE_SHOWN"
  | "RETURNS_EXPERIENCE_MODAL_OPENED"
  | "RETURNS_EXPERIENCE_MODAL_DISMISSED"
  | "RETURNS_EXPERIENCE_REMIND_LATER"];

/**
 * Sends a returns experience event with `isRedoUser`, so Redo staff, who can
 * switch freely, can be left out of the merchant funnel.
 */
export function useTrackReturnsExperience(): (
  event: ReturnsExperienceEvent,
  properties?: Record<string, string>,
) => void {
  const user = useContext(UserContext);
  return useHandler(
    (event: ReturnsExperienceEvent, properties?: Record<string, string>) => {
      amplitude.track(event, {
        ...properties,
        isRedoUser: isRedoEmailAddress(user?.email),
      });
    },
  );
}
